import "./index.css";
import { useState } from "react";
import Slides from "./Slides";

function App() {
  const [showSlides, setShowSlides] = useState(false);
  return (
    <div>
      <nav>
        <div className="logo">Arsel DIFFO</div>
        <ul>
          <li><a href="#about">A propos</a></li>
          <li><a href="#skills">Competences</a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#projects">Projets</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>

      <div className="hero">
        <section className="hero-content">
          <span className="hero-tag">Disponible - Ile-de-France</span>
          <h1>Stayer Arsel<br/><span>DIFFO SOUOP</span></h1>
          <p>Ingenieur Systemes and Reseaux oriente Cloud and DevSecOps - Master 2 SUPINFO Paris.</p>
          <div className="hero-btns">
            <a href="#projects" className="btn-primary">Voir mes projets</a>
            <a href="#contact" className="btn-secondary">Me contacter</a>
          </div>
        </section>
      </div>

      <section id="about">
        <div className="divider"></div>
        <h2 className="section-title">A <span>propos</span></h2>
        <p className="section-sub">Qui suis-je ?</p>
        <div className="about-grid">
          <div className="about-text">
            <p>Passionne par les infrastructures cloud et l automatisation, je suis etudiant en Master 2 Systemes, Reseaux and Cloud a SUPINFO Paris.</p>
            <p>J ai acquis une solide experience en administration systeme Windows/Linux, securisation d infrastructures et supervision reseau.</p>
            <p>Je maitrise les outils DevOps modernes : Terraform, Ansible, Docker, Kubernetes, GitHub Actions, Prometheus et ELK Stack.</p>
          </div>
          <div className="about-stats">
            <div className="stat-card"><div className="val">4+</div><div className="lbl">Experiences pro</div></div>
            <div className="stat-card"><div className="val">12</div><div className="lbl">Ressources Azure</div></div>
            <div className="stat-card"><div className="val">0%</div><div className="lbl">Erreurs sous charge</div></div>
            <div className="stat-card"><div className="val">21</div><div className="lbl">Taches Ansible</div></div>
          </div>
        </div>
      </section>

      <section id="skills">
        <div className="divider"></div>
        <h2 className="section-title">Compe<span>tences</span></h2>
        <p className="section-sub">Stack technique maitrisee</p>
        <div className="skills-grid">
          <div className="skill-card">
            <h3>Cloud and Infrastructure</h3>
            {[["Microsoft Azure",85],["Terraform",80],["Ansible",80],["Linux / Windows Server",90]].map(([n,p])=>(
              <div className="skill-item" key={n}>
                <div className="skill-label"><span>{n}</span><span>{p}%</span></div>
                <div className="skill-bar"><div className="skill-bar-fill" style={{width:p+"%"}}></div></div>
              </div>
            ))}
          </div>
          <div className="skill-card">
            <h3>DevOps and CI/CD</h3>
            {[["Docker",85],["Kubernetes AKS",80],["GitHub Actions",80],["Trivy Security",75]].map(([n,p])=>(
              <div className="skill-item" key={n}>
                <div className="skill-label"><span>{n}</span><span>{p}%</span></div>
                <div className="skill-bar"><div className="skill-bar-fill" style={{width:p+"%"}}></div></div>
              </div>
            ))}
          </div>
          <div className="skill-card">
            <h3>Supervision and Reseau</h3>
            {[["Prometheus / Grafana",75],["ELK Stack",70],["Zabbix / Nagios",80],["Reseaux TCP/IP",85]].map(([n,p])=>(
              <div className="skill-item" key={n}>
                <div className="skill-label"><span>{n}</span><span>{p}%</span></div>
                <div className="skill-bar"><div className="skill-bar-fill" style={{width:p+"%"}}></div></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="experience">
        <div className="divider"></div>
        <h2 className="section-title">Expe<span>rience</span></h2>
        <p className="section-sub">Mon parcours professionnel</p>
        <div className="experience-list">
          {[
            {title:"Technicien IT Systemes and Reseaux",company:"Kamtar - Stage",period:"Mai 2025 - Septembre 2025",missions:["Administration serveurs Windows et Linux","Support utilisateurs niveau 1","Supervision avec Zabbix","Securisation des acces"],results:["Stabilite systeme amelioree","Incidents reduits"]},
            {title:"Administrateur Reseaux et Systeme",company:"CAMPOST - CDI",period:"Novembre 2023 - Septembre 2024",missions:["Administration serveurs pour 5 services hospitaliers","Deploiement regles de securite","Scripts d automatisation"],results:["Stabilite renforcee","Securite donnees patients"]},
            {title:"Technicien Systeme",company:"Ministere de la Sante - Stage",period:"Janvier 2023 - Aout 2023",missions:["Administration serveurs Windows and Linux","Supervision Nagios et Zabbix","Gestion incidents via GLPI","200+ comptes utilisateurs"],results:["-30% interruptions reseau","+25% performances"]},
            {title:"Technicien Reseau",company:"Matrix Telecoms SA - Stage",period:"Juin 2021 - Septembre 2021",missions:["Configuration switches et firewalls","Installation liaisons inter-agences"],results:["+25% performances reseau","Disponibilite inter-sites"]},
          ].map((exp,i)=>(
            <div className="exp-card" key={i}>
              <div className="exp-header">
                <div><div className="exp-title">{exp.title}</div><div className="exp-company">{exp.company}</div></div>
                <span className="exp-period">{exp.period}</span>
              </div>
              <div className="exp-missions">
                <h4>Missions</h4>
                <ul>{exp.missions.map((m,j)=><li key={j}>{m}</li>)}</ul>
              </div>
              <div className="exp-results">{exp.results.map((r,j)=><span className="result-badge" key={j}>{r}</span>)}</div>
            </div>
          ))}
        </div>
      </section>

      <section id="projects">
        <div className="divider"></div>
        <h2 className="section-title">Pro<span>jets</span></h2>
        <p className="section-sub">Realisations techniques</p>
        <div className="projects-grid">
          <div className="project-card">
            <span className="tag">Projet phare - Master 2</span>
            <h3>Plateforme DevSecOps - Azure Kubernetes</h3>
            <p>Infrastructure cloud complete : Terraform, Ansible, pipeline CI/CD 4 jobs, Kubernetes AKS, Prometheus + Grafana + ELK Stack.</p>
            <div className="project-techs">{["Terraform","Ansible","Docker","Kubernetes","GitHub Actions","Prometheus"].map(t=><span className="tech-tag" key={t}>{t}</span>)}</div>
            <button onClick={() => setShowSlides(true)} className="btn-primary" style={{marginTop:"0.5rem",cursor:"pointer",border:"none",fontSize:"0.9rem"}}>Voir la presentation ?</button>
            <a href="http://20.87.90.91" className="project-link" target="_blank" rel="noreferrer">Voir live <span className="project-live">LIVE</span></a>
          </div>
          <div className="project-card">
            <span className="tag">Portfolio</span>
            <h3>Portfolio React sur Kubernetes</h3>
            <p>Ce portfolio est deploye sur Kubernetes via un pipeline CI/CD automatise. Build React, Docker multi-stage, push ACR, deploy AKS.</p>
            <div className="project-techs">{["React","Docker","Kubernetes","Azure ACR","GitHub Actions"].map(t=><span className="tech-tag" key={t}>{t}</span>)}</div>
            <a href="https://github.com/ARSEL123" className="project-link" target="_blank" rel="noreferrer">GitHub</a>
          </div>
        </div>
      </section>

      <section id="contact">
        <div className="divider"></div>
        <h2 className="section-title">Con<span>tact</span></h2>
        <p className="section-sub">Disponible pour des opportunites</p>
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Travaillons ensemble</h3>
            <p>Je suis a la recherche d opportunites en DevOps, Cloud ou SRE.</p>
            <div className="contact-items">
              <div className="contact-item"><div className="icon">@</div><div className="text"><div className="label">Email</div><div className="val">diffoarsel123@gmail.com</div></div></div>
              <div className="contact-item"><div className="icon">T</div><div className="text"><div className="label">Telephone</div><div className="val">07 59 38 19 27</div></div></div>
              <div className="contact-item"><div className="icon">L</div><div className="text"><div className="label">Localisation</div><div className="val">Ile-de-France, France</div></div></div>
              <div className="contact-item"><div className="icon">G</div><div className="text"><div className="label">Formation</div><div className="val">Master 2 - SUPINFO Paris</div></div></div>
            </div>
          </div>
          <div className="contact-card">
            <h3>Voir mes projets</h3>
            <p>Retrouvez mon code sur GitHub</p>
            <a href="https://github.com/ARSEL123" className="btn-primary" target="_blank" rel="noreferrer">GitHub</a>
          </div>
        </div>
      </section>

      {showSlides && <Slides onClose={() => setShowSlides(false)} />}
      <footer>
        <p>Stayer Arsel DIFFO SOUOP - Ingenieur Systemes and Reseaux oriente Cloud and DevSecOps - SUPINFO Paris 2025/2026</p>
      </footer>
    </div>
  );
}

export default App;
